import Accordion from "../../../../../components/Accordion/Accordion";
import RequisitiPerIscrizione from "./RequisitiPerIscrizione";
import TrattamentoDatiPersonali from "./TrattamentoDatiPersonali";
import Button from "../../../../../components/Button/Button";
import {useHistory} from "react-router";
import Valutazione from "./Valutazione";
import {useDispatch, useSelector} from "react-redux";
import AssistentiService from "../../../../../services/AssistentiService";
import Utils from "../../../../../utils/Utils";
import AnagraficaService from "../../../../../services/AnagraficaService";
import {deleteStateUpload, setStateAssistente} from "../../../../../actions/IndexActions";
import ApmsService from "../../../../../services/ApmsService";
import React, {useEffect, useState} from "react";
import Enums from "../../../../../utils/Enums.json"
import ModaleAnnulla from "../../../../../components/modaleAnnulla/ModaleAnnulla";
import Spinner from "../../../../../components/spinner/Spinner";

function RequisitiCondizioni(props) {
    const requisitiPerIscrizione = (<div><RequisitiPerIscrizione/></div>)
    const trattamentoDatiPersonali = (<div><TrattamentoDatiPersonali/></div>)
    const valutazione = (<Valutazione/>)
    const [pagination, setPagination] = useState({size: 5, page: 0, sort: "nome", order: "asc"})
    const sigleProvince = JSON.parse(sessionStorage.getItem("siglaProvincePerCodice"))
    const [utenteLoggato, setUtenteLoggato] = useState({})
    const [sportelloUtente, setSportelloUtente] = useState({})
    const [siglaProvincia, setSiglaProvincia] = useState("")
    const history = useHistory()
    const dispatch = useDispatch()
    const getAssistente = useSelector(state => state.wizardReducer)
    const sessioneUtente = sessionStorage.getItem("sessioneUtente") ? JSON.parse(sessionStorage.getItem("sessioneUtente")) : {}
    const fileReducer = useSelector(state => state.fileReducer)
    const nazioniPerCodice = JSON.parse(sessionStorage.getItem("nazioniPerCodice"))
    const comuniPerCodice = JSON.parse(sessionStorage.getItem("comuniPerCodice"))
    const siglaProvincePerCodice = JSON.parse(sessionStorage.getItem("siglaProvincePerCodice"))
    const [showSpinner, setShowSpinner] = useState(false)

    useEffect(() => {
        if (sessioneUtente && sessioneUtente.tipoUtente === "01") {
            getUtenti()
        }
    }, [])

    function getUtenti() {
        let params = {
            applicazione: "RAF",
            size: pagination.size,
            page: pagination.page,
            sort: pagination.sort,
            order: pagination.order.toLowerCase(),
            codiceFiscale: sessioneUtente?.codiceFiscale?.toUpperCase()
        }
        ApmsService.ricercaUtenti(params).then(res => {
            let listaUtenti = res.data.elementi[0]
            setUtenteLoggato(listaUtenti)
            let ente = "";
            if (listaUtenti && listaUtenti.gruppi && listaUtenti.gruppi[0].attributi) {
                listaUtenti.gruppi[0].attributi.forEach(attributo => {
                    if (attributo.codiceAttributo === "RAF-ente") {
                        ente = attributo.valore
                    }
                })
            }

            let enteSplit = ente.split(";")
            let comuneUtente = comuniPerCodice[enteSplit[1]] ?? null
            let siglaProvincia = comuneUtente && comuneUtente.codiceProvincia ? sigleProvince[comuneUtente.codiceProvincia].descrizione : ""
            setSportelloUtente(enteSplit[0] ?? "")
            setSiglaProvincia(siglaProvincia)

        }).catch(reason => {
            console.log("Errore Operation GET Utenti: " + reason)
        })

    }

    function onClickButtonAnnulla() {
        let path = sessioneUtente && sessioneUtente.tipoUtente === "01" ? "/registro" : "/home"
        history.push({
            pathname: path
        })
    }

    function createJson() {

        let paramsWizard = {
            idCandidato: getAssistente.assistente && getAssistente.assistente.idCandidato ? getAssistente.assistente.idCandidato : "",
            datiPersonali: {
                infoGenerali: getAssistente.infoGenerali
            },
            lavoroDisponibilita: {
                esperienzeLavorative: getAssistente.esperienzeLavorative,
                disponibilitaOfferta: getAssistente.disponibilitaOfferta
            },
            requisitiCondizioni: {
                requisitiIscrizione: getAssistente.requisitiIscrizione,
                datiPersonali: getAssistente.datiPersonali,
                valutazione: getAssistente.valutazione
            }
        }

        if (getAssistente.disponibilitaOfferta && getAssistente.disponibilitaOfferta.comune && getAssistente.disponibilitaOfferta.comune.length > 0) {
            let p = {
                type: "MultiPoint",
                coordinates: []
            }
            getAssistente.disponibilitaOfferta.comune.forEach(c => {
                let coordinatesComune = [c.longitudine, c.latitudine]
                p.coordinates.push(coordinatesComune)
            })
            paramsWizard.lavoroDisponibilita.disponibilitaOfferta.location = p
        }
        return paramsWizard
    }

    function inserimentoWizard() {
        setShowSpinner(true)
        let jsonInserimento = createJson()
        let jsonInsertCandidato = Utils.createJsonInsertCandidato(getAssistente.datiAnagrafici)
        AnagraficaService.inserisciCandidato(Utils.removeEmptyValueFromObject(jsonInsertCandidato)).then(resInserimentoCandidato => {
            jsonInserimento.idCandidato = resInserimentoCandidato.data.idCandidato
            AssistentiService.inserisciAssistente(jsonInserimento).then(res => {
                if (sessioneUtente && sessioneUtente.tipoUtente === "01") {
                    insertReport()
                }
                uploadFile(jsonInserimento.idCandidato, 1)
                let path = sessioneUtente.tipoUtente === "01" ? "/registro" : "home"
                window.alert(Enums.TOASTERTYPE.SUCCESS.descrizione, "Operazione avvenuta con successo");
                history.push({
                    pathname: path,
                    steps: [{
                        nome: "1. DATI PERSONALI",
                        codiceStep: "01",
                        cliccabile: true
                    }, {
                        nome: "2. LAVORO E DISPONIBILITA'",
                        codiceStep: "02",
                        cliccabile: true
                    }, {nome: "3. REQUISITI E CONDIZIONI", codiceStep: "03", cliccabile: true}],
                    stepAttivo: "01"
                })
            }).catch(reason => {
                setShowSpinner(false)
                console.log("Errore Operation POST Assistente: " + reason)
            })
        }).catch(reason => {
            setShowSpinner(false)
            console.log("Errore Operation POST Candidato: " + reason)
        })
    }

    function modificaWizard() {
        setShowSpinner(true)
        let json = Utils.removeEmptyObject(createJson())
        let idAssistente = getAssistente.assistente.idAssistente
        let jsonInsertCandidato = Utils.createJsonInsertCandidato(getAssistente.datiAnagrafici)
        AnagraficaService.modificaCandidato(Utils.removeEmptyValueFromObject(jsonInsertCandidato)).then(resInserimentoCandidato => {
            let idCandidato = resInserimentoCandidato.data.id
            if (sessioneUtente.tipoUtente === "02") {
                AnagraficaService.getCandidato(resInserimentoCandidato.data.id).then(resGetCandidato => {
                    let datiAnagraficiAssistente = Utils.createObjectDatiAnagraficiAssistente(resGetCandidato.data, comuniPerCodice, siglaProvincePerCodice, nazioniPerCodice, false)
                    dispatch(setStateAssistente("datiAnagrafici", datiAnagraficiAssistente ? datiAnagraficiAssistente : {}))
                    callToModificaAssistente(idAssistente, json, idCandidato)
                }).catch(reason => {
                    setShowSpinner(false)
                    console.log("Errore Operation GET Candidato: " + reason)
                })
            } else {
                callToModificaAssistente(idAssistente, json, idCandidato)
            }
        }).catch(reason => {
            setShowSpinner(false)
            console.log("Errore Operation PUT Candidato: " + reason)
        })
    }

    function callToModificaAssistente(idAssistente, json, idCandidato) {
        AssistentiService.modificaAssistente(idAssistente, json).then(res => {
            uploadFile(idCandidato, 2)
            let path = sessioneUtente.tipoUtente === "01" ? "/registro" : "home"
            window.alert(Enums.TOASTERTYPE.SUCCESS.descrizione, "Operazione avvenuta con successo");
            history.push({
                pathname: path,
                steps: [{
                    nome: "1. DATI PERSONALI",
                    codiceStep: "01",
                    cliccabile: true
                }, {
                    nome: "2. LAVORO E DISPONIBILITA'",
                    codiceStep: "02",
                    cliccabile: true
                }, {nome: "3. REQUISITI E CONDIZIONI", codiceStep: "03", cliccabile: true}],
                stepAttivo: "01"
            })
        }).catch(reason => {
            setShowSpinner(false)
            console.log("Errore Operation PUT Assistente: " + reason)
        })
    }

    function validateConferma() {
        if (getAssistente && getAssistente.requisitiIscrizione) {
            let stateRequisitiIscrizione = getAssistente.requisitiIscrizione
            if (!(stateRequisitiIscrizione.iscriversiRegistro && stateRequisitiIscrizione.iscriversiRegistro.checkboxStep3IscriversiRegistro10) ||
                !(stateRequisitiIscrizione.impegna && stateRequisitiIscrizione.impegna.checkboxStep3SiImpegna1) ||
                !(stateRequisitiIscrizione.impegna && stateRequisitiIscrizione.impegna.checkboxStep3SiImpegna2) ||
                !(stateRequisitiIscrizione.impegna && stateRequisitiIscrizione.impegna.checkboxStep3SiImpegna3)
            ) return true
        }

        if (getAssistente && getAssistente.datiPersonali) {
            let stateDatiPersonali = getAssistente.datiPersonali

            if (!(stateDatiPersonali.terminiCondizioni && stateDatiPersonali.terminiCondizioni.checkboxStep3TerminiCondizioni1) ||
                !(stateDatiPersonali.terminiCondizioni && stateDatiPersonali.terminiCondizioni.checkboxStep3TerminiCondizioni2)
            ) return true
        }
    }

    function onClickButtonConfermaRegistrazione() {
        if (getAssistente && getAssistente.assistente && getAssistente.assistente.idCandidato) modificaWizard()
        else inserimentoWizard()
    }

    function insertReport() {
        let jsonParam = {
            idReport: 2,
            nomeSportello: sportelloUtente
        }

        if (getAssistente.disponibilitaOfferta && getAssistente.disponibilitaOfferta.stato && (getAssistente.disponibilitaOfferta.stato === "01" || getAssistente.disponibilitaOfferta.stato === "02")) {
            jsonParam.siglaProvincia = siglaProvincia
        }
        Utils.putReport(jsonParam)
    }

    function uploadFile(idCandidato, tipo) {
        let jsonParam = {
            idCandidato: idCandidato,
            documentoIdentita: fileReducer && fileReducer.documentoIdentita ? fileReducer.documentoIdentita : "",
            permessoSoggiorno: fileReducer && fileReducer.permessoSoggiorno ? fileReducer.permessoSoggiorno : "",
            attestati: fileReducer && fileReducer.attestati ? fileReducer.attestati : ""
        }
        dispatch(deleteStateUpload())
        if (tipo === 1) {
            AssistentiService.uploadFile(Utils.removeEmptyValueFromObject(jsonParam)).then(res => {
                setShowSpinner(false)
            }).catch(reason => {
                setShowSpinner(false)
                console.log("Errore Operation Caricamento File: " + reason)
            })
        } else if (tipo === 2) {
            AssistentiService.modificaUploadFile(idCandidato, Utils.removeEmptyValueFromObject(jsonParam)).then(res => {
                setShowSpinner(false)
            }).catch(reason => {
                setShowSpinner(false)
                console.log("Errore Operation Caricamento File: " + reason)
            })
        }
    }

    return (
        <div style={{marginTop: "2rem"}}>
            <Spinner show={showSpinner}/>
            <span style={{fontSize: "24px"}}>Compila Scheda Assistente (3 di 3)</span>
            <div style={{marginTop: "2rem"}}>
                <Accordion
                    id={"AccordionRequisitiPerIscrizione"}
                    headerText={"Requisiti per iscrizione"}
                    accordionBody={requisitiPerIscrizione}
                />
                <Accordion
                    id={"AccordionTrattamentoDatiPersonali"}
                    headerText={"Trattamento dei dati personali"}
                    accordionBody={trattamentoDatiPersonali}
                />
                {sessioneUtente && sessioneUtente.tipoUtente === "01"?<Accordion
                    id={"AccordionValutazione"}
                    headerText={"Valutazione"}
                    accordionBody={valutazione}
                />:<></>}
            </div>
            <div className={"row"}>
                <div className={"col-6"} style={{textAlign: "left"}}>
                    <Button
                        id={"ButtonAnnulla"}
                        typeButton={"White"}
                        disabled={false}
                        text={"Annulla"}
                        style={{minHeight: "50px", minWidth: "150px"}}
                        dataTarget={"modalModificaUtente"}
                        dataToggle={"modal"}
                        dataBackdrop={"static"}
                        dataKeyboard={false}
                        body={<ModaleAnnulla onClick={onClickButtonAnnulla}/>}
                        header={"Attenzione!"}
                    />
                </div>
                <div className={"col-6"} style={{textAlign: "right"}}>
                    <Button
                        id={"ButtonConfermaRegistrazione"}
                        onClick={onClickButtonConfermaRegistrazione}
                        typeButton={"Blue"}
                        disabled={validateConferma()}
                        text={getAssistente && getAssistente.assistente && getAssistente.assistente.idCandidato ? "Salva ed esci" : "Conferma Registrazione"}
                        style={{minHeight: "50px", minWidth: "150px"}}
                    />
                </div>
            </div>
        </div>
    )
}

export default RequisitiCondizioni
